// extracted by mini-css-extract-plugin
export default {"container":"Category_container__p9uyj","slider-container":"Category_slider-container__Rj5-v","slider-item":"Category_slider-item__gY2mh","paper":"Category_paper__lPsJs"};